/* EO Design – full-screen mobile menu: keeps the drawer starting directly below the header bar. */
(() => {
  const mq = window.matchMedia('(max-width: 749px)');

  const update = () => {
    const details = document.getElementById('Details-menu-drawer-container');
    const header = document.querySelector('header.header-section');
    if (!details || !header || !mq.matches) return;
    const bottom = Math.round(header.getBoundingClientRect().bottom);
    document.documentElement.style.setProperty('--eo-menu-top', `${bottom}px`);
  };

  const init = () => {
    const details = document.getElementById('Details-menu-drawer-container');
    if (!details) return;
    new MutationObserver(update).observe(details, { attributes: true, attributeFilter: ['open', 'class'] });
    details.querySelector('summary')?.addEventListener('click', update, { capture: true });
    window.addEventListener('resize', update);
    update();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
